import React from 'react';
import PropTypes from 'prop-types';
import { Input as AntInput } from 'antd';
import { classNames } from 'utils';
import './input.scss';

const InputUIKit = ({ ...rest }) => {
  return <AntInput className={classNames('ui-kit-input')} {...rest} />;
};

InputUIKit.propTypes = {
  rest: PropTypes.any,
};

export default InputUIKit;
